/**
 * A centered layout for card-based pages like AcceptInvite.
 */
export function CenteredCardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="w-screen min-w-96 flex justify-center items-center min-h-screen">
      <div className="max-w-md w-full mx-4">{children}</div>
    </div>
  );
}
